export default function () {

  const $viewportWidth = $(window).width();
  const $heroContainer = $('.hero-section');
  const $videoContainer = $('.video-container');

  if ($viewportWidth > 1079) {
    $videoContainer.html('<video src="../img/baxdela-maze-video.mp4" autoplay muted></video>');

    $('video').on('ended', function() {
      // animation effect reference: https://daneden.github.io/animate.css/
      $videoContainer.addClass('animated fadeOut');
      $heroContainer.addClass('hero-background animated zoomIn');
    });
  } else {
    $heroContainer.addClass('hero-background');
  }

}


// WEBPACK FOOTER //
// ./js/modules/hero-video.js